import { useVariables, useValues, Value, VariableT } from '@k3/core';
import { InvalidSelectionWarningProps } from '@k3/core/dist/src/lib/components/InvalidSelectionWarning';
import { ValidOrInvalidOption } from '@k3/core/dist/src/lib/engine/ruleEngine2/types';
import { noSelectionKey, switchAndSubvariableKeys } from './InvalidRuleModal';

const isPotentialConflictOnlyWithOptionalValue = (
  invalidOption: ValidOrInvalidOption | undefined,
  variables: VariableT[],
  values: Value[],
  switchVariableKey: string,
  subVariableKey: string
) => {
  if (!invalidOption || invalidOption.conflicts.length !== 1) {
    return false;
  }

  const switchVariable = variables?.find((v) => v.key === switchVariableKey);

  const isValueOfSwitchVariable =
    invalidOption?.value?.variableId === switchVariable?.id;

  if (isValueOfSwitchVariable) {
    const subvariable = variables?.find((v) => v.key === subVariableKey);
    const subVariableOptionalValue = values.find(
      (v) => v.key === noSelectionKey && v.variableId === subvariable?.id
    );
    const isConflictWithOptionalValueOfSubvariable =
      invalidOption.conflicts[0].variableId === subvariable?.id &&
      invalidOption.conflicts[0].valueId === subVariableOptionalValue?.id;

    return isConflictWithOptionalValueOfSubvariable;
  }

  return false;
};

export const InvalidSelectionWarning =
  (Wrapped: any) => (props: InvalidSelectionWarningProps) => {
    const invalidOption = props.invalidOption;
    const variables = useVariables();
    const values = useValues();

    if (
      switchAndSubvariableKeys.some(({ switchVariableKey, subVariableKey }) =>
        isPotentialConflictOnlyWithOptionalValue(
          invalidOption,
          variables,
          values,
          switchVariableKey,
          subVariableKey
        )
      )
    ) {
      return null;
    }

    return <Wrapped {...props} />;
  };
